<template>
  <div>
    <CCardBody>
      <!-- filter -->
      <FilterRpl 
        :searchDataPesertaSertifikasi="searchDataPesertaSertifikasi" 
        :dataSertifikasi="dataSertifikasi"
      />
      <!-- end filter -->
      <CRow>
        <CCol sm="6" lg="12">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{index+1}}</td>
            </template>
            
            <template #kategori_anggota="{item}">
              <td class="py-2">{{ item.kategori_anggota ? item.kategori_anggota : '-' }}</td>
            </template>
            <template #persyaratanDokumen="{item}">
              <td class="py-2">{{ item.persyaratanDokumen ? item.persyaratanDokumen : '-' }}</td>
            </template>
            <template #nama_lengkap="{item}">
              <td
                class="py-2 text-info"
                style="cursor: pointer"
                @click="detailUser(item, index)"
              >{{ item.nama_lengkap ? item.nama_lengkap : '-' }}</td>
            </template>
            <template #tgl_daftar="{item}">
              <td class="py-2">{{ item.tgl_daftar ? item.tgl_daftar : '-' }}</td>
            </template>
            <template #tanggal_daftar="{item}">
              <td class="py-2">{{ item.tanggal_daftar ? item.tanggal_daftar : '-' }}</td>
            </template>
            <template #status_pembayaran="{item}">
              <td
                class="py-2 text-success font-weight-bold"
                v-if="item.status_pembayaran == 'settlement'"
              >Lunas</td>
              <td
                class="py-2 text-purple font-weight-bold"
                v-else-if="item.status_pembayaran == 'pending'"
              >Menunggu Pembayaran</td>
              <td
                class="py-2 text-secondary font-weight-bold"
                v-else-if="item.status_pembayaran == 'expired'"
              >Expired</td>
              <td
                class="py-2 text-secondary font-weight-bold"
                v-else-if="item.status_pembayaran == 'failure'"
              >Pembayaran Gagal</td>
              <td
                class="py-2 text-danger font-weight-bold"
                v-else-if="item.status_pembayaran == 0"
              >Belum Lunas</td>
              <td class="py-2 text-danger font-weight-bold" v-else>
                Belum Lunas
              </td>
            </template>
            <template #_status="{item}">
              <td class="py-2">
                <font-awesome-icon icon="check" class="text-success" v-if="item._status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item}">
              <td class="py-2 text-center">
                <router-link
                  :to="'/sertifikasi/data-peserta/sertifikasi-rpl/detail-sertifikasi-rpl/'+item.id_sertifikasi_rpl_peserta"
                >
                  <CButton v-c-tooltip="'Lihat Mata Uji Peserta'" color="success" class="btn-sm" square>
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </CButton>
                </router-link>&nbsp;&nbsp;
                <router-link
                  :to="'/sertifikasi/data-peserta/sertifikasi-rpl/dokumen-sertifikasi-rpl/'+item.id_sertifikasi_rpl_peserta"
                >
                  <CButton v-c-tooltip="'Lihat Dokumen Peserta'" color="warning" class="btn-sm text-white" square>
                    <i class="fa fa-file" aria-hidden="true"></i>
                  </CButton>
                </router-link>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPageDataPesertaSertifikasi"
            :pages="pagination.totalPages"
            responsive
          />
        </CCol>
      </CRow>
      <!-- Modal Detail User -->
    </CCardBody>
  </div>
</template>
<script>
import DataPesertaRplService from "../../../../services/sertifikasi/data-peserta-rpl.service";
// import MasterSertifikasiService from "../../../../services/sertifikasi/master-sertifikasi.service";
import { AlertUtils } from "../../../../mixins/AlertUtils";
import { Pagination } from "../../../../mixins/Pagination";
import FilterRpl from "../../../../components/rpl/datapeserta/FilterRpl";
import ModalDetailPesertaSertifikasi from "../../../../components/sertifikasi/datapeserta/ModalDetailPesertaSertifikasi";
import { KategoriAnggota } from "../../../../mixins/master/KategoriAnggota";

const fields = [
  {
    key: "no",
    sorter: true,
    filter: false,
  },
 
  {
    key: "nama_lengkap",
    label: "Nama",
    sorter: true,
    filter: false,
  },
  {
    key: "kategori_anggota",
    label: "Kategori Anggota",
    sorter: true,
    filter: false,
  },
  {
    key: "tanggal_daftar",
    label: "Tanggal Daftar",
    sorter: true,
    filter: false,
  },

  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: true,
    filter: false,
  },
  {
    key: "aksi",
    _style: "width:10%; text-align: center",
    sorter: false,
    filter: false,
  },
];

export default {
  mixins: [AlertUtils, Pagination, KategoriAnggota],
  components: {
    FilterRpl,
  },
  data() {
    return {
      items: [],
      sertifikasi: "",
      kategori_anggota: "",
      formData: {
        nama_kategori: "",
        nama_lengkap: "",
        noTelephone: "",
        noTelephone: "",
        tangga_jatuh_tempo: "",
        no_handphone: "",
        email: "",
        nama: "",
        noTelephone: "",
        password: "",
        id_user: "",
      },
      idKategoriSertifikasiRpl: "",
      dataSertifikasi: [],
      details: [],
      fields,
      status: false,
      myModal: false,
      modalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      loading: true,
    };
  },

  mounted() {
    // this.getData("0", this.pageSize, this.searchDataPesertaSertifikasi, this.id_sertifikasi);
    // this.getSertifikasiRpl(
    //   "0",
    //   this.pageSize,
    //   this.searchDataPesertaSertifikasi,
    //   this.idKategoriSertifikasiRpl
    // );
  },

  methods: {
    // pageChange() {
    //   this.getData(currentPage);
    // },
    filterTanggal(e) {
      this.searchDataPesertaSertifikasi = e.target.value
    },

    pilihStatusPembayaran(e) {
      this.modelStatusPembayaran = e.target.value;
      this.modelIdSertifikasi = 'default'
      this.getData("0", this.pageSize, this.searchSertifikasi, 'default',this.modelStatusPembayaran);

    },

    getData(currentPage, pageSize, filter, id_sertifikasi,status_pembayaran) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel,
      });

      var vm = this;
      // comment console console.log(currentPage)
      // comment console console.log(pageSize)
      // comment console console.log(  filter)
      // comment console console.log( id_sertifikasi);

      DataPesertaRplService.getDataPeserta(
        currentPage,
        pageSize,
        filter,
        id_sertifikasi,
        status_pembayaran
      )
        .then((response) => {
          loader.hide();

          // comment console console.log(response.data.data.content);

          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages;
          vm.currentPageDataPesertaSertifikasi = response.data.data.pageable.pageNumber + 1;
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },

    getSertifikasiRpl(idKategoriSertifikasiRpl) {
      DataPesertaRplService.getSertifikasiRpl(idKategoriSertifikasiRpl)
        .then((response) => {
          this.dataSertifikasi = response.data.data;
          // comment console console.log("INIIII" + this.dataSertifikasi)
        })
        .catch((error) => {
          // comment console console.log(error);
        });
    },    

    detailUser(item, index) {
      this.modalDetail = true;
      this.formData = item;
    },

    changeKategoriRpl(value) {
      this.getSertifikasiRpl(value.idKategoriSertifikasiRpl);
    },

    changeSertifikasi(value) {
      this.modelStatusPembayaran = 'default'
      this.getData("0", this.pageSize, this.searchDataPesertaSertifikasi, value.idSertifikasiRpl);
      this.idSertifikasi = value.idSertifikasiRpl;
      // alert("hah")
      // // comment console console.log('idi id sertifikasi' + value.idSertifikasiRpl);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
